<template>
  <div>

      <div style="background: white">
        <div class="headBar f-b-c">
          <div>
            <el-image :src="logo" style="height: 86px; width: 129px;"></el-image>
          </div>
          <div v-if="!username()" @click="$router.push('home')" class="hover-pointer">Sign in</div>
          <el-dropdown @command="handleCommand" v-else>
            <span class="el-dropdown-link">
              {{username()}}<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="m">Modify Password</el-dropdown-item>
              <el-dropdown-item command="e">Exit</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>

      <div class="menuBar f-c-c">
        <a class="f-c-c h100" v-for="(item, index) in menuBarList" :key="item.title" @click="topage(item)">
          <div class="menu" :class="{'actMenu': $route.path === `/${item.title.toLowerCase()}`}">
            <div>{{item.title}}</div>
          </div>
          <div class="borderLine" v-if="index !== menuBarList.length - 1"></div>
        </a>
      </div>

      <div class="contents">
        <TabMains></TabMains>
      </div>

      <div class="bottomBar f-c-c">
      © 2008 - 2021&nbsp;&nbsp;|&nbsp;&nbsp;<u>Terms of Use</u>&nbsp;&nbsp;|&nbsp;&nbsp;<u>Privacy Notice</u>
    </div>

  </div>
</template>

<script>
import TabMains from './tabMains'

export default {
  name: 'homePage',
  components: {
    TabMains
  },
  data () {
    return {
      logo: require('../../static/img/logo.png'),
      background: require('../../static/img/background.png'),
      leftMenu: [
        {
          title: 'Home page',
          icon: 'home',
          child: [
            {
              title: 'Work management'
            }
          ]
        }
      ],
      menuBarList: [
        {
          title: 'Home'
        },
        {
          title: 'Shine'
        },
        {
          title: 'Epi-clock'
        },
        {
          title: 'Wind'
        },
        {
          title: 'About'
        },
        {
          title: 'Feedback'
        }
      ]
    }
  },
  computed: {
    username: function () {
      return function () {
        return this.$cookie.get('sw_username')
      }
    }
  },
  methods: {
    topage (item) {
      this.$router.push(item.title.toLowerCase())
    },
    handleCommand (code) {
      if (code === 'm') {
        this.$router.push({path: '/modifyPassword'})
      } else if (code === 'e') {
        this.$confirm('Are you sure to log out?', ' ', {
          confirmButtonText: 'yes',
          cancelButtonText: 'no',
          type: 'warning'
        }).then(() => {
          this.$http({
            url: this.$http.adornUrl('/sys/logout'),
            method: 'post',
            data: this.$http.adornData()
          }).then(({data}) => {
            if (data && data.code === 0) {
              this.$message.success('Logging Out successfully')
              this.$cookie.delete('sw_token')
              this.$cookie.delete('sw_username')
              if (this.$route.path === '/home') {
                this.$router.go(0)
              } else {
                this.$router.replace('home')
              }
            }
          })
        }).catch(() => {})
      }
    }
  }
}
</script>

<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.headBar {
  background: white;
  width: 50%;
  height: 102px;
  min-width: 960px;
  margin: auto;
}
.menuBar {
  background: #084e4e;
  height: 48px;
  padding: 0 15%;
}
.menu {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #084e4e;
  height: 100%;min-width: 150px;
  color: white;cursor: pointer;
}
.borderLine {
  background: white;width: 1px;height: 30%
}
.actMenu{
  background: #b2be52;
}
.bottomBar {
  font-size: 13px;margin-top:-30px;
  height: 0px;min-height: 30px;
}

.el-dropdown-link {
  cursor: pointer;
}
.el-icon-arrow-down {
  font-size: 12px;
}
* /deep/ .el-dropdown-menu__item {display: block; margin: 0px}
* /deep/ .el-dropdown-menu__item:focus, .el-dropdown-menu__item:not(.is-disabled):hover {
  background: #D7DF8A;
  color: #000
}
</style>



// WEBPACK FOOTER //
// src/components/homePage.vue